import { Button, Group } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import React, { useState } from 'react';
import { Field, Form } from '~/app//shared/components/Form';
import { Column, Row } from '~/app//shared/components/Grid/Grid';
import openApiClient from '../../../shared/util/api/openApiClient';
import { EXTERNAL_BILLINGS_URL } from './constants';
import EditExternalBillingItemDtoFormSchema from './EditExternalBillingItemDtoFormSchema';
import { ExternalBillingItemDto } from './types';

interface Props {
    data?: ExternalBillingItemDto;
    onClose: () => void;
    onSubmitted: () => void;
}

export default function EditExternalBillingItemDtoForm({ data, onClose, onSubmitted }: Props) {
    const [submitting, setSubmitting] = useState<boolean>(false);

    const submit = async (value: ExternalBillingItemDto) => {
        setSubmitting(true);

        await openApiClient.put(EXTERNAL_BILLINGS_URL, value).then(() => {
            setSubmitting(false);
            onClose();
        });
    };

    return (
        <Form
            onSubmit={submit}
            validationSchema={EditExternalBillingItemDtoFormSchema}
            initialData={data}
            onSubmitted={onSubmitted}>
            <Row divided>
                <Column>
                    <Field.Number label={t`Discount percentage`} name="discountPercentage" required />
                </Column>
                <Column>
                    <Field.DatePicker label={t`Discount expiry`} name="discountExpiry" required />
                </Column>
            </Row>
            <div className="form__buttons">
                <Group>
                    <Button onClick={onClose}>
                        <Trans>Cancel</Trans>
                    </Button>
                    <Button appearance="primary" disabled={submitting} type="submit">
                        <Trans>Save</Trans>
                    </Button>
                </Group>
            </div>
        </Form>
    );
}
